export default __webpack_public_path__ + "static/media/cern-medium.39fc5795.eot";